import React from 'react'
import { IconProps } from '../../types/types'

const IconSun:React.FC<IconProps> = ({ size = '16', color = 'white' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.78574 12.003C10.1149 12.003 12.003 10.1149 12.003 7.78574C12.003 5.45661 10.1149 3.56848 7.78574 3.56848C5.45661 3.56848 3.56848 5.45661 3.56848 7.78574C3.56848 10.1149 5.45661 12.003 7.78574 12.003Z" stroke={color} strokeWidth="1.16786" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.4182 12.4182L12.3339 12.3339M12.3339 3.23755L12.4182 3.1532L12.3339 3.23755ZM3.1532 12.4182L3.23755 12.3339L3.1532 12.4182ZM7.7857 1.34951V1.29761V1.34951ZM7.7857 14.2738V14.2219V14.2738ZM1.34951 7.7857H1.29761H1.34951ZM14.2738 7.7857H14.2219H14.2738ZM3.23755 3.23755L3.1532 3.1532L3.23755 3.23755Z" stroke={color} strokeWidth="1.55714" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default IconSun